<template>
  <div class="auth-container">
    <h1>Enter new password</h1>

    <form v-if="!isResetSuccess" @submit.prevent="submit">
      <div class="form-group">
        <label>Password</label>
        <div class="input-wrapper">
          <input
            type="password"
            v-model.trim="$v.formModel.password.$model"
            placeholder="Password"
            autofocus
          />
        </div>
      </div>

      <div class="form-group">
        <label>Confirm password</label>
        <div class="input-wrapper">
          <input
            type="password"
            v-model.trim="$v.formModel.passwordConfirm.$model"
            placeholder="Confirm password"
          />
        </div>
      </div>

      <div v-for="error in errors" :key="error" class="auth-error">
        {{ error }}
      </div>

      <div class="submit-group">
        <button :disabled="isSubmitDisabled || $v.$invalid" class="btn btn-blue">Reset</button>
      </div>
    </form>

    <div v-else class="reset-success">
      <p>Password was reseted</p>
      <router-link class="blue-link" to="/login">Go to login page</router-link>
    </div>

  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  sameAs,
} from 'vuelidate/lib/validators';
import { proccessError } from '@/helpers/utils';

export default {
  name: 'ResetPassword',
  data: () => ({
    formModel: {
      password: '',
      passwordConfirm: '',
    },
    errors: [],
    isResetSuccess: false,
    isSubmitDisabled: false,
  }),
  validations: {
    formModel: {
      password: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(50),
      },
      passwordConfirm: {
        sameAsPassword: sameAs('password'),
      },
    },
  },
  watch: {
    formModel: {
      handler() {
        this.errors = [];
      },
      deep: true,
    },
  },
  methods: {
    async submit() {
      this.isSubmitDisabled = true;

      const { token } = this.$route.params;

      try {
        await this.$store.dispatch('auth/resetPassword', { password: this.formModel.password, token });
        this.isResetSuccess = true;
      } catch (e) {
        this.isSubmitDisabled = false;
        this.errors = proccessError(e.response.data);
      }
    },
  },
};
</script>

<style lang="less" scoped>
  .reset-success {
    text-align: center;

    p {
      background-color: #7ce7f2;
      border-radius: 5px;
      padding: 15px;
      color: #202020;
      max-width: 400px;
      margin: 0 0 30px;
    }
  }
</style>
